export interface CartItemAddon {
  id: string;
  name: string;
  price: number;
}

export interface CartItem {
  id: string;
  /** Product catalog id when the line comes from an order API response. */
  productId?: string;
  vendorId: string;
  vendorName: string;
  title: string;
  description?: string;
  price: number;
  vendorPrice?: number;
  quantity: number;
  imageUrl?: string;
  imageUrls?: string[];
  maxQuantityPerOrder?: number;
  /** Unit of measurement (e.g. kg, pack, 100g). Enriched from product when returning orders. */
  unit?: string;
  /** Variant id (e.g. productId_index). Used with productId for cart identity when product has variants. */
  variantId?: string;
  variant?: {
    name: string;
    price: number;
  };
  addons?: CartItemAddon[];
  specialInstructions?: string;
}

export interface CartTotals {
  itemCount: number;
  subtotal: number;
  taxes: number;
  fees: number;
  total: number;
}

export type CartQuantityResult =
  | { ok: true }
  | { ok: false; reason: 'max_quantity'; max: number };

/** Parse vendor max-per-order; returns null when unset or invalid. */
export function parseMaxQuantityPerOrder(value: unknown): number | null {
  if (value == null || value === '') return null;
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return null;
  return Math.floor(n);
}
